<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Monthly Attendance Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month" :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="inst" :items="employee_list" item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <p><b>Designation</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="designation" :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <p><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list" item-text="name" item-value="id" label="Employee Section" outlined />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn
                            class="button"
                            v-if="sal_month"
                            @click="fetchMonthlyAttenadance();loader = true;">
                            Fetch Report
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            employee_type_list: [],
            employee_list: [],
            inst:null,
            designation_list: [],
            sal_month: null,
            sal_month_copy: null,
            inst_list: null,
            employee_type: null,
            employee: null,
            designation: null,
            overlay: false,
            section_list:null,
            section:null
        }),
       
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            fetchMonthlyAttenadance(){
                 const data = {
                    sal_month: this.sal_month,
                    employee_type: this.employee_type,
                    designation: this.designation,
                    section: this.section,
                    emp:this.inst
                };
                 this.overlay = true;
                axios
                    .post("/EmployeeBiometric/fetchMonthlyAttenadance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.overlay = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.show_copy_dialog = true;
                    });
            },
            onLoad() {
                axios
                    .post("/Payroll/getInitialData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                            this.employee_type_list = res.data.employee_type_list;
                            this.section_list = res.data.section_list;
                            this.designation_list = res.data.designation_list;
                            this.employee_list = res.data.employee_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
